import LiveWorldScene, {LiveAppContext} from "../../LiveWorldScene";
import Phaser from "phaser";
import VenueDefinition from "../../VenueDefinition";

type BaseSound = Phaser.Sound.BaseSound;
type Tilemap = Phaser.Tilemaps.Tilemap;

export default class DancePartyWorldScene extends LiveWorldScene {
    danceMusic: BaseSound | null = null
    musicIntervalId: NodeJS.Timeout | null = null

    constructor(
        public worldKey: string,
        public mapKey: string,
        public backOnBounds: boolean,
        public appContext: LiveAppContext,
        venue: VenueDefinition) {
        super(worldKey, mapKey, backOnBounds, appContext, venue);
    }

    create() {
        super.create();
        if (!this.danceMusic) {
            this.danceMusic = this.sound.add('dance');
        }

        if (this.appContext.isAudioActive()) {
            setTimeout(() => {
                this.danceMusic!.play({
                    loop: true
                });
            }, 300)
        }

        let audioActive = this.appContext.isAudioActive()
        this.musicIntervalId = setInterval(() => {
            const audioActiveNow = this.appContext.isAudioActive()
            if (audioActive !== audioActiveNow) {
                if(audioActiveNow){
                    this.danceMusic!.play({
                        loop: true
                    });
                } else {
                    this.danceMusic!.pause()
                }
            }
            audioActive = audioActiveNow
        }, 1000)
    }

    shutDown() {
        super.shutDown();
        this.danceMusic!.pause()
        clearInterval(this.musicIntervalId!)
    }

    processMapFeatures(map: Tilemap) {
        super.processMapFeatures(map);
        const dancerPoints = map.filterObjects("Objects", (obj) => {
            return obj.type === "Dancer"
        })
        dancerPoints.forEach((pt) => this.makeDancer(pt as Phaser.GameObjects.Shape))
    }

    makeDancer(pt: Phaser.GameObjects.Shape) {
        let dancer = this.add.sprite(pt.x, pt.y, "dancers", 0)
        dancer.setSize(56, 56)
        dancer.anims.play(pt.name, true);
    }


    createAnimations() {
        super.createAnimations();
        this.anims.create({
            key: 'dancer1',
            frames: this.anims.generateFrameNumbers('dancers', {
                frames: [0, 1, 2, 3, 2, 1, 0]
            }),
            frameRate: 4,
            repeat: -1
        });
        this.anims.create({
            key: 'dancer2',
            frames: this.anims.generateFrameNumbers('dancers', {
                frames: [4, 5, 6, 7, 6, 5, 4]
            }),
            frameRate: 4,
            repeat: -1
        });
        this.anims.create({
            key: 'dancer3',
            frames: this.anims.generateFrameNumbers('dancers', {
                frames: [8, 9, 10, 11, 10, 9, 8]
            }),
            frameRate: 4,
            repeat: -1
        });
        this.anims.create({
            key: 'dancer4',
            frames: this.anims.generateFrameNumbers('dancers', {
                frames: [12, 13, 14, 15, 14, 13, 12]
            }),
            frameRate: 4,
            repeat: -1
        });
    }
}
